(function ($) {
  'use strict';
  this.LaVuelta2024 = function () {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.dispatchEventType) {
        window.dispatchEventType(
          document,
          'SkodaAnalytics:Promotions:AddElements',
          undefined,
          undefined,
          undefined,
          {
            elements: document.querySelectorAll('#product-banner a'),
            context: 'La Vuelta 2024',
          }
        );
      }
    });
  };
}).bind(window)(jQuery);
